import { render, staticRenderFns } from "./tooltip_default_format.vue?vue&type=template&id=0319cca2"
import script from "./tooltip_default_format.vue?vue&type=script&lang=js"
export * from "./tooltip_default_format.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports